import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableEquipmentAlerts extends Layout {
    sourceUnitMessage: DataSource;
    tableEquipAlerts: Table;
}
